export var FrameSideType;
(function (FrameSideType) {
    FrameSideType[FrameSideType["None"] = 0] = "None";
    FrameSideType[FrameSideType["Small"] = 1] = "Small";
    FrameSideType[FrameSideType["Big"] = 2] = "Big";
})(FrameSideType || (FrameSideType = {}));
export var FrameComponentType;
(function (FrameComponentType) {
    FrameComponentType[FrameComponentType["Left"] = 0] = "Left";
    FrameComponentType[FrameComponentType["Right"] = 1] = "Right";
    FrameComponentType[FrameComponentType["Top"] = 2] = "Top";
    FrameComponentType[FrameComponentType["Bottom"] = 3] = "Bottom";
    FrameComponentType[FrameComponentType["Content"] = 4] = "Content";
})(FrameComponentType || (FrameComponentType = {}));
export var FrameSegmentType;
(function (FrameSegmentType) {
    FrameSegmentType[FrameSegmentType["Gap"] = 0] = "Gap";
    FrameSegmentType[FrameSegmentType["Empty"] = 1] = "Empty";
    FrameSegmentType[FrameSegmentType["Simple"] = 2] = "Simple";
    FrameSegmentType[FrameSegmentType["Complex"] = 3] = "Complex";
    FrameSegmentType[FrameSegmentType["ComplexEmpty"] = 4] = "ComplexEmpty";
})(FrameSegmentType || (FrameSegmentType = {}));
